import { inject, Injectable, DOCUMENT } from '@angular/core';
import { KeyCloakConstants } from '@dss-libs/shared/type/common-types';

import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root',
})
export class KeycloakAuthService {
  private readonly keycloakService = inject(Keycloak);
  private readonly document = inject(DOCUMENT);
  public get clientId() {
    return this.keycloakService.clientId;
  }

  public isLoggedIn(): boolean {
    return !!this.keycloakService.authenticated;
  }

  public getToken(): string | undefined {
    return this.keycloakService.idToken;
  }

  public getParsedToken(): any {
    return this.keycloakService.tokenParsed;
  }
  public login(): void {
    this.keycloakService.login();
  }

  public signWithProviderAndRedirectBack(idpHint: string, redirectUri: string): Promise<void> {
    return this.keycloakService.login({ idpHint, redirectUri });
  }

  public async refreshSession(tokens?: any): Promise<void> {
    const kc = this.keycloakService;

    if (tokens && tokens.refreshToken) {
      kc.token = tokens.token;
      kc.refreshToken = tokens.refreshToken;
      kc.idToken = tokens.idToken;
      kc.authenticated = true;

      try {
        await this.keycloakService.updateToken(-1);
      } catch (error) {
        console.error('Failed to sync Keycloak session in main window', error);
        kc.clearToken();
        throw error;
      }
    }
  }

  public registerWithProviderAndRedirectBack(idpHint: string, redirectUri: string): Promise<void> {
    return this.keycloakService.register({ idpHint, redirectUri });
  }

  public logout(redirectUrl?: string) {
    return this.keycloakService.logout({
      redirectUri: redirectUrl || this.document.location.origin,
    });
  }

  public changePassword(redirectUrl?: string) {
    return this.keycloakService.login({
      redirectUri: redirectUrl || this.document.location.origin,
      action: KeyCloakConstants.UPDATE_PASSWORD,
      prompt: 'login',
    });
  }
}
